import React from 'react';
import { Box, Card, Typography, Stack } from '@mui/joy';

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {
	const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
	const campaignData = [3,7,4,12,9,11,8,6,10,5,8,7];
	const outcomeData = [5,8,6,15,10,13,9,7,12,8,11,10];
	const maxCampaign = Math.max(...campaignData);
	const maxOutcome = Math.max(...outcomeData);

	return (
		<Box sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr', sm:'1fr 1fr', lg:'repeat(4, 1fr)' }, gap:2, p:2 }}>
      <Card variant="outlined" sx={{ p: 2 }}>
        <Typography level="title-sm" fontWeight="bold" sx={{ mb: 1 }}>
          Campagne assegnate
        </Typography>
        <Typography level="h2" sx={{ mb: 0.5 }}>3</Typography>
        <Typography level="body-xs" color="success" sx={{ mb: 2 }}>
          8% nuovi lead
        </Typography>
        
        <Box sx={{ position: 'relative', height: 60 }}>
          <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: 0 }}>
            <Box sx={{ 
              position: 'absolute', 
              bottom: 0, 
              left: 0, 
              right: 0, 
              height: '1px', 
              bgcolor: 'neutral.300' 
            }} />
            
            <Box sx={{ 
              position: 'absolute',
              bottom: 0,
              left: 8,
              right: 8,
              top: 0
            }}>
              <Box
                component="svg"
                viewBox="0 0 100 40"
                preserveAspectRatio="none"
                sx={{
                  width: '100%',
                  height: '100%'
                }}
              >
                <polyline
                  fill="none"
                  stroke="#1976d2"
                  strokeWidth="1.5"
                  points={campaignData.map((value, index) => {
                    const x = (index / (campaignData.length - 1)) * 100;
                    const y = 40 - (value / maxCampaign) * 35;
                    return `${x},${y}`;
                  }).join(' ')}
                />
                
                {campaignData.map((value, index) => {
                  const x = (index / (campaignData.length - 1)) * 100;
                  const y = 40 - (value / maxCampaign) * 35;
                  return (
                    <circle
                      key={index}
                      cx={x}
                      cy={y}
                      r="1.2"
                      fill="#1976d2"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
        
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          mt: 1,
          px: 0.5
        }}>
          {months.map((month) => (
            <Typography key={month} level="body-xs" sx={{ 
              fontSize: '0.65rem',
              transform: 'scale(0.9)',
              transformOrigin: 'center'
            }}>
              {month}
            </Typography>
          ))}
        </Box>
      </Card>

			<Card variant="outlined" sx={{ p:2 }}>
				<Typography level="title-sm" fontWeight="bold" sx={{ mb:1 }}>Lead da lavorare</Typography>
				<Typography level="h2" sx={{ mb:0.5 }}>58</Typography>
				<Typography level="body-xs" color="success" sx={{ mb:2 }}>12% vs settimana scorsa</Typography>
				<Box sx={{ display:'flex', alignItems:'center', gap:2 }}>
					<Box>
						<Typography level="h4">12</Typography>
						<Typography level="body-xs">Lead gestite oggi</Typography>
					</Box>
					<Typography level="body-xs" color="neutral">3min 45s</Typography>
				</Box>
			</Card>

			<Card variant="outlined" sx={{ p:2, display:'flex', flexDirection:'column', alignItems:'center' }}>
				<Typography level="title-sm" fontWeight="bold" sx={{ mb:1, alignSelf:'flex-start' }}>Lead con esito positivo</Typography>
				<Box sx={{ position:'relative', width:150, height:150, mb:1 }}>
					<Box sx={{ position:'absolute', top:0, left:0, width:'100%', height:'100%', borderRadius:'50%', background:'conic-gradient(#4f46e5 0deg 230deg, #e5e7eb 230deg 360deg)', display:'flex', alignItems:'center', justifyContent:'center' }}>
						<Box sx={{ width:100, height:100, borderRadius:'50%', bgcolor:'white', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column' }}>
							<Typography level="h4">37</Typography>
							<Typography level="body-xs" textColor="text.secondary">su 58</Typography>
						</Box>
					</Box>
				</Box>
			</Card>

			<Card variant="outlined" sx={{ p:2 }}>
				<Typography level="title-sm" fontWeight="bold" sx={{ mb:1 }}>Esiti contatto mensili</Typography>
				<Stack spacing={1} sx={{ mb:2 }}>
					<Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
						<Box sx={{ width:8, height:8, bgcolor:'error.500', borderRadius:'2px' }} />
						<Typography level="body-xs">Non interessato</Typography>
					</Box>
					<Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
						<Box sx={{ width:8, height:8, bgcolor:'warning.500', borderRadius:'2px' }} />
						<Typography level="body-xs">Riconfattare</Typography>
					</Box>
					<Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
						<Box sx={{ width:8, height:8, bgcolor:'success.500', borderRadius:'2px' }} />
						<Typography level="body-xs">Lead valida</Typography>
					</Box>
				</Stack>
				<Box sx={{ display:'flex', alignItems:'end', gap:0.5, height:30 }}>
					{months.map((m,i)=>(
						<Box key={m} sx={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center' }}>
							<Box sx={{ width:'80%', height:`${(outcomeData[i]/maxOutcome)*25}px`, bgcolor:'primary.500', borderRadius:'4px 4px 0 0', minHeight:2 }} />
						</Box>
					))}
				</Box>
				<Box sx={{ display:'flex', justifyContent:'space-between', mt:0.5 }}>
					{months.map(m=>(
						<Typography key={m} level="body-xs" sx={{ fontSize:'0.7rem' }}>{m}</Typography>
					))}
				</Box>
			</Card>
		</Box>
	);
};

export default KPISet;
